import * as React from 'react';
import { styled } from '@mui/material';
import { fontFamily, weights } from '../context/CerebroThemeProvider';

type InputProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
	error?: boolean;
	small?: boolean;
};

// eslint-disable-next-line react/display-name
const Input = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => <input ref={ref} {...props} />);

export type CerebroInputProps = React.ComponentProps<typeof CerebroInput>;

export const CerebroInput = styled(Input, { shouldForwardProp: prop => prop !== 'error' && prop !== 'small' })(
	({ small = false, error = false, disabled, readOnly, theme }) => ({
		borderWidth: 2,
		borderStyle: 'solid',
		borderRadius: theme.shape.borderRadius,
		borderColor: error
			? theme.palette.error.main
			: disabled || readOnly
			? theme.palette.gray.light
			: theme.palette.gray.medium,

		color: disabled ? theme.palette.gray.light : theme.palette.gray.dark,
		cursor: disabled ? 'not-allowed' : 'initial',

		fontFamily,
		fontSize: 12,
		fontWeight: disabled ? weights.medium : weights.semibold,

		lineHeight: '14px',
		marginBottom: theme.spacing(1),
		marginTop: theme.spacing(1.5),
		padding: !small ? '14px 12px' : 8,

		outline: 'none',
		width: '100%',

		'&:focus:not(:read-only)': {
			borderColor: error ? theme.palette.error.light : theme.palette.primary.main,
		},

		'&::placeholder': {
			color: theme.palette.gray.medium,
		},
	})
);
